import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircle } from "@fortawesome/free-solid-svg-icons";
import './index.css'
// TODO: The component logic needs to be changed - Not a generic component

const Stepper = (props: any) => {
  const steps: any = [];

  let current = props.selected; //1

  for (let i = 0; i <= props.selected; i++) {
    steps.push(
      <span className="font-wrapper">
        {i !== 0 && <hr style={{width: "30px"}} />}
        <FontAwesomeIcon
          color="#24d07e"
          icon={faCircleCheck}
          className="font"
          style={{fontSize: "22px", border: "1px solid #24d07e"}}
        />
        <span style={{ color: "black"}}>{props.steps[i]}</span>
      </span>
    );
  }

  current = current + 1;

  if (current < props.steps.length) {
    steps.push(
      <span className="font-wrapper">
        <hr style={{width: "30px"}} />
        <FontAwesomeIcon
            color="white"
          icon={faCircle}
          style={{fontSize: "20px"}}
          className="font font-bd-green"
        />
        <span>{props.steps[current]}</span>
      </span>
    );
  }

  current = current + 1;
  for(let i = current; i<props.steps.length; i++){
    steps.push(
      <span className="font-wrapper">
        <hr style={{width: "30px"}} />
        <FontAwesomeIcon
          color="#e0e0e0"
          icon={faCircle}
          style={{fontSize: "20px"}}
          className="font font-bd-gray"
        />
        <span>{props.steps[current]}</span>
      </span>
    );
  }

  return <div className="stepper_wrapper">
    <div className="row">
      <div className="col-md-12" style={{display: "flex", justifyContent: "center", alignItems: "center", fontSize:'14px'}}>
      {steps}
      </div>
    </div>
  </div>;
};

export default Stepper;
